import { defineComponent } from 'vue';

export default defineComponent({
  components: {
  },
  data() {
    return {
      clicked: false,
    };
  },
  methods: {
    scrollToTop() {
      this.clicked = true;
      setTimeout(() => {
        this.clicked = false;
      }, 300);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
  template: '#t-footer-to-top',
});
